import React from "react";
import { Helmet } from "react-helmet-async";
import "./Error.scss";

const Error = () => {
  return (
    <div className="error d-flex justify-content-center text-align-center">
      <Helmet><title>Сторінку не знайдено | ARYN Lyrics</title></Helmet>
      <h2>
        Вибачте, але цієї сторінки не існує
      </h2>
    </div>
  );
};

export default Error;